import * as types from './mutation-types'
import Vue from 'vue'
import { IUmbClasseState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbUmbClasse, IAloDbUmbClasseConstParam } from '@/models/alodb/AloDbUmbClasse';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IUmbClasseState> = {
     
    //Gestion des recherches de missions
    [types.UMBCLASSE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.UmbClasse.Title').toString()}).toString()
        state.umbClasseLoading = true
    },
    [types.UMBCLASSE_SUCCESS]: (state, umbClasses:Array<AloDbUmbClasse>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.UmbClasse.Title').toString()}).toString()
        state.umbClasses = umbClasses   
        state.umbClasseLoading = false             
    },
    [types.UMBCLASSE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UmbClasse.Title').toString()}).toString()
        state.umbClasses = []
        state.umbClasseLoading = false
    },
    [types.UMBCLASSE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.UmbClasse.Title').toString()} ${itemId}`}).toString()
        state.umbClasseLoading = true
    },
    [types.UMBCLASSE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UmbClasse.Title').toString()}).toString()
        state.umbClasseLoading = false
    },
    [types.UMBCLASSE_SELECT_DETAIL_SUCCESS]: (state,umbClasse:AloDbUmbClasse) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.UmbClasse.Title').toString()} ${umbClasse.UMC_ID}`}).toString()        
        //1, on met à jour de m'umbClasse dans la liste des umbClasses
        const index = state.umbClasses.findIndex(m => m.UMC_ID == umbClasse.UMC_ID)
        state.umbClasses.splice(index == -1 ? state.umbClasses.length : index, index == -1 ? 0 : 1, umbClasse)
        state.umbClasseLoading = false
    },
    [types.UMBCLASSE_SELECT_DETAIL]: (state,umbClasse:AloDbUmbClasse) => {                
        state.originalAdmUmbClasse = umbClasse
        state.modifiedAdmUmbClasse = new AloDbUmbClasse(umbClasse)
    },
    [types.UMBCLASSE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.UmbClasse.Title').toString()} ${libelle}`}).toString()
        state.umbClasseLoading = true
    },
    [types.UMBCLASSE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.UmbClasse.Title').toString()}).toString()
        state.umbClasseLoading = false
    },
    [types.UMBCLASSE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmUmbClasse = {...state.modifiedAdmUmbClasse,...newProperties}
    },
    [types.UMBCLASSE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }       
}


export default mutations
